import React from 'react'
import { Link } from 'react-router-dom'
import { LuMapPin, LuMail, LuPhone } from 'react-icons/lu'
import Logo from '../../Asset/navbar/logo.png'

const Footer = () => {
  return (
    <footer className='footer_container'>
      <div className='footer_content'>
        <div className='footer_left'>
          <div className='footer_logo'>
            <img src={Logo} alt='MindMatrix Labs' />
          </div>
          <p className='footer_about'>
            We collaborate with industry leaders to bring real-world learning experiences to educational institutions, helping students build future-ready skills.
          </p>
        </div>

        <div className='footer_middle'>
          <h3>Quick links</h3>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/college'>Colleges</Link></li>
            <li><Link to='/student'>Students</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/contact'>Contact us</Link></li>
            <li><a href='https://lms.mindmatrix.io/login' target='_blank' rel='noopener noreferrer'>Register</a></li>
          </ul>
        </div>

        <div className='footer_right'>
          <h3>Contact us</h3>
          <p><LuMapPin size={16} />MindMatrix, Kiran Arcade, 4th Floor, Sector 1, HSR Layout, Bangalore, Karnataka, India</p>
          <p><LuPhone size={16} /><a href='tel:+919611546444'>+91 96115 46444</a></p>
          <p><LuMail size={16} /><a href='mailto:contact@mindmatrix.io'>contact@mindmatrix.io</a></p>
        </div>
      </div>

      <div className='footer_bottom'>
        {`© ${new Date().getFullYear()} MindMatrix Labs. All rights reserved.`}
      </div>
    </footer>
  )
}

export default Footer
